import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAuth } from '../../contexts/auth'
import {substringUserName as substr, FIO_ALLOWED_MESSAGE, FAMILIA_ALLOWED_MESSAGE, IMYA_ALLOWED_MESSAGE, OTCHESTVO_ALLOWED_MESSAGE, FIO_PATTERN, FIO_PATTERN_OPTIONAL} from './../../utils/string.utils'
import './profile.scss';
import Form, {
  ButtonItem,
  ButtonOptions,
  CustomRule,
  GroupItem,
  Item,
  SimpleItem,
  Label,
  RequiredRule,
  StringLengthRule,
  EmailRule, PatternRule
} from 'devextreme-react/form'
import {
  updateUser,
  updatePassword,
  deleteAccount,
  generateFingerpint,
  sendPhoneChange,
  sendEmail
} from '../../api/auth'
import notify from 'devextreme/ui/notify'
import { getRegions } from '../../api/outer';
import {Button} from "devextreme-react/button";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import {faUserMinus} from "@fortawesome/free-solid-svg-icons";
import {Popup} from "devextreme-react";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import SmsPopupDifferent, {formatSmsCountdown, useSmsTypeOpTimer} from "../../components/sms-popup/sms-popup-different";
import LoadPanel from "devextreme-react/load-panel";
import {getPass, validPass} from "../../utils/get-password-rules";
import Validator from "devextreme/ui/validator";

let formInstancePass, formInstancePhone, formInstanceEmail//, formInstance

const Profile = () => {
  const { user, setUser, signOut } = useAuth();
  const [visible, setVisible] = useState(false)
  const eyeclose = require("./../../assets/eyeclose.svg").default
  const eyeopen = require("./../../assets/eyeopen.svg").default
  const [passwordCurrentIcon, setPasswordCurrentIcon] = useState(eyeclose)
  const [passwordIcon, setPasswordIcon] = useState(eyeclose)
  const [passwordConfirmIcon, setPasswordConfirmIcon] = useState(eyeclose)
  const extFileUploaderRef1 = useRef({});
  const extFileUploaderRef2 = useRef({});
  const strMinRuleMessage = 'Недопустимое кол-во символов!'
  const formDataFIO = useRef({
    Фамилия: user.lastName,
    Имя: user.firstName,
    Отчество: user.middleName,
    phone: user.mobilePhone
  })
  const formDataPass = useRef({
    Текущий_пароль: null,
    Новый_пароль: null,
    Подтверждение_пароля: null
  })
  const formDataFile = useRef({})
  const formDataMobilePhone = useRef( {phone: user.mobilePhone})
  const [loading, setLoading] = useState(false)
  const formDataEmail = useRef({email: user.email})
  const [disabledFIO, setDisabledFIO] = useState(true)
  //const [disabledMobilePhoneButton, setDisabledMobilePhoneButton] = useState(false)
  const [disabledPass, setDisabledPass] = useState(true)
  const [regions, setRegions] = useState([])
  const [userRegion, setUserRegion] = useState(user.region)
  const [messageSendSms, setMessageSendSms] = useState('Ошибка')
  const [uid, setUid] = useState(null)
  const [typeOp, setTypeOp] = useState(2);
  const [messageLoadPanel, setMessageLoadPanel] = useState(`Отправка СМС...`);
  const [timerStart, setTimerStart] = useState(false)
  const [lifeTimeSeconds, setLifeTimeSeconds] = useState(null);
  const profileSmsRemaining = useSmsTypeOpTimer(2)
  const [passwordRulesLabel, setPasswordRulesLabel] = useState('Пароль должен состоять минимум из 8 символов, содержать как минимум одну цифру и 2 заглавные буквы')
  const [authSettings, setAuthSettings] = useState( {})
  const [disablePhoneSendWhereEquvivOldAndNew, setDisablePhoneSendWhereEquvivOldAndNew] = useState(user.mobilePhone === user.mobile_phone_c && user.is_active_phone)
  const [disableEmailSendWhereEquvivOldAndNew, setDisableEmailSendWhereEquvivOldAndNew] = useState(user.email === user.email_c && user.is_active_email)

    useEffect(() => {
      formDataMobilePhone.current.phone = user.mobile_phone_c
      setDisablePhoneSendWhereEquvivOldAndNew(user.mobilePhone === user.mobile_phone_c  && user.is_active_phone)
    }, [user.mobilePhone,user.is_active_phone,user.mobile_phone_c])

    useEffect(() => {
      formDataEmail.current.email = user.email
      setDisableEmailSendWhereEquvivOldAndNew(user.email === user.email_c && user.is_active_email)
    }, [user.email, user.email_c, user.is_active_email])

  useEffect(() => {
    (async function(){
      const resRegions = await getRegions()
      if (resRegions.isOk) {
        setRegions(resRegions.data)
      }
    })()
  },[user.region])

  useEffect(() => {
    (async function () {
      try {
        const res = await getPass()
        //res.data.smsNotify = true
        setPasswordRulesLabel(res)
        setAuthSettings(res?.data)
      } catch (e) {
        notify(e.message, 'error', 5000)
      }
    })()
  }, [])

  const editFio = async (e) => {
    e.preventDefault()
    setDisabledFIO(!disabledFIO)
    if (!disabledFIO) {
      const res = await updateUser(formDataFIO.current)
      if (res.isOk) {
        setUser((prev) => ({
          ...prev,
          ...res.data,
          roles: res.data.roles ?? prev?.roles,
        }))
        notify('Профиль успешно изменен!', 'success', 5000)
      } else notify(res.message, 'error', 5000)
    }
  }

  const editEmail = async (e) => {
    e.preventDefault()
    const email = formDataEmail.current.email
    const res = await sendEmail(email)
    if (res.isOk) {
      //setUser(res.data)
      notify(res.data.message, 'success', 5000)
    } else {
      notify(res.message, 'error', 5000)
    }
  }

  const editPhone = async (e) => {
    e.preventDefault()
    try {
      const {phone} = formDataMobilePhone.current;
      setMessageLoadPanel(`Отправка СМС...`)
      setTypeOp(2)
      setLoading(true);
      const fingerprint = await generateFingerpint()
      const result = await sendPhoneChange('+7' + phone, fingerprint);
      if (!result.uid) {
        notify(result.message, 'error', 5000);
      } else {
        setUid(result.uid)
        setMessageSendSms(result.message)
        setTimerStart(true)
      }
    } catch (e) {
      notify(e.message, 'error', 5000);
    } finally {
      setLoading(false);
    }
  }

  const editPassword = async (e) => {
    e.preventDefault()
    setDisabledPass(!disabledPass)
    if (!disabledPass) {

      const res = await updatePassword(formDataPass.current.Текущий_пароль, formDataPass.current.Новый_пароль)
      if (res.isOk) {
        notify(res.message, 'success', 5000)
        formDataPass.current = {
          Текущий_пароль: null,
          Новый_пароль: null,
          Подтверждение_пароля: null
        }
        e.target.reset()
      } else {
        setDisabledPass(false)
        notify(res.message, 'error', 5000)

      }
    }
  }

  const confirmPassword = useCallback(({ value }) => {
    const newPass = formDataPass.current.Новый_пароль
    if (newPass === null) return true
    return value === newPass
  },[]);

  const fioEditor = {
    disabled: disabledFIO
  }

  const [passwordMode, setPasswordMode] = useState('password')
  const passwordEditor = {
    disabled: disabledPass,
    placeholder: 'Пароль',
    mode: passwordMode,
    valueChangeEvent:"keyup",
    onValueChanged:async (e) => {
      const editor = formInstancePass && formInstancePass.getEditor('Подтверждение_пароля');
      if (editor && editor.option('value')) {
        const instance = Validator.getInstance(editor.element());
        instance.validate();
      }

      const editorPassword = formInstancePass && formInstancePass.getEditor('Новый_пароль');
      if (editorPassword) {
        const instance = Validator.getInstance(editorPassword.element());
        if (await validPass(e.value, passwordRulesLabel.data)) {
          instance._validationRules[0].isValid = false
        }
        instance.validate();
      }
    },
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordIcon,
        type: 'default',
        onClick() {
          setPasswordMode(passwordMode === 'text' ? 'password' : 'text');
          setPasswordIcon(passwordIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  }
  const [passwordConfirmMode, setPasswordConfirmMode] = useState('password')
  const passwordConfirmEditor = {
    disabled: disabledPass,
    mode: passwordConfirmMode,
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordConfirmIcon,
        type: 'default',
        onClick() {
          setPasswordConfirmMode(passwordConfirmMode === 'text' ? 'password' : 'text');
          setPasswordConfirmIcon(passwordConfirmIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  }
  const [passwordCurrentMode, setPasswordCurrentMode] = useState('password')
  const passwordCurrentEditor = {
    disabled: disabledPass,
    mode: passwordCurrentMode,
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordCurrentIcon,
        type: 'default',
        onClick() {
          setPasswordCurrentMode(passwordCurrentMode === 'text' ? 'password' : 'text');
          setPasswordCurrentIcon(passwordCurrentIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  }

  const regionOptions = {
    disabled: disabledFIO,
    dataSource: regions,
    valueExpr: "idRegion",
    displayExpr: "nameRegion",
    value: userRegion,
    onValueChanged: function(e){
      setUserRegion(e.value)
    },
    searchEnabled: true
  }

  const phoneOptions = {
    disabled: disabledFIO,
    mask: '+7 (YX0) 000-0000',
    maskRules: { X: /[01-9]/, Y: /[9]/ }
  }

  const emailOptions = {
    placeholder: 'Email',
    mode: 'email',
    icon:'email',
    valueChangeEvent:"keyup",
    buttons: [{
      name: 'email',
      location: 'after',
      valueChangeEvent:"keyup",
      options: {
        icon: 'check', // или 'email', 'user', 'calendar', и т.д.
        stylingMode:"text",
        type: disableEmailSendWhereEquvivOldAndNew ? "success":"danger",
        hint: disableEmailSendWhereEquvivOldAndNew ? 'Email подтвержден' : 'Email не подтвержден',
        disabled:true,
      },
    }],
    onValueChanged:async () => {
      const editor = formInstanceEmail && formInstanceEmail.getEditor('email');
      if (editor?.option('value')) {
        const emailNew = editor.option('value')
        setDisableEmailSendWhereEquvivOldAndNew(
            user.email === user.email_c && user.email === emailNew && user.is_active_email
        )
      }
    },
  }

  const mobilePhoneOptions = {
    mask: '+7 (YX0) 000-0000',
    maskRules: { X: /[01-9]/, Y: /[9]/ },
    valueChangeEvent:"keyup",
    buttons: [{
      name: 'mobilePhone',
      location: 'after',
      options: {
        icon: 'check', // или 'email', 'user', 'calendar', и т.д.
        stylingMode:"text",
        type: disablePhoneSendWhereEquvivOldAndNew ? "success":"danger",
        hint: disablePhoneSendWhereEquvivOldAndNew ? 'Телефон подтвержден' : 'Телефон не подтвержден',
        disabled:true,
      },
    }],
    onValueChanged:async () => {
      const editor = formInstancePhone && formInstancePhone.getEditor('phone');
      if (editor?.option('value')) {
        const phoneNew = '+7' + editor.option('value')
        setDisablePhoneSendWhereEquvivOldAndNew(
            user.mobilePhone === user.mobile_phone_c && user.mobilePhone === phoneNew && user.is_active_phone
        )
      }
    },
  }

  const onBtnPopupClick = async () => {
    setVisible(true)
  }

  const onDelProfileClick = async () => {
    const result = await deleteAccount(user.id);
    if (result.isOk) {
      notify(result.message, 'success', 5000);
    } else {
      notify(result.message, 'error', 5000);
    }
    setVisible(false)
    signOut()
  }

  const [newdogFiles, setNewdogFiles] = useState(new Map())

  const onValueChanged = (files, type) => {
    let source = newdogFiles
    if (files.length > 0) {
      files.map(e => {
        if (!e.delfiles) {
          source.set(e.name, {
            id: newdogFiles.size + 1000000,
            type_name: type,
            file_name: e.name,
            file: e
          })
        } else {
          source.delete(e.name)
        }
        return null;
      })
    }
    setNewdogFiles(source)
  }

  const saveDopInfo = async (e) => {
    e.preventDefault()
  }


  return (
      <React.Fragment>
        <div className={'profile'}>
          <div className={'content-block dx-card responsive-paddings'}>
            <div className={'form-avatar main-background-color'}>
              {/* <img
              alt={''}
              src={`https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${
                employee.Picture
              }`}
            /> */}
              {substr(user)}
            </div>
            <h5>{user.lastName + ' ' + user.firstName + ' ' + (user.middleName ? user.middleName : '')}</h5>
            {user.email && !passwordRulesLabel?.data?.smsNotify && <h6>{user.email}</h6>}
            {passwordRulesLabel?.data?.smsNotify && user.email_c === user.email &&
                <h6>{user.email}</h6>
            }
            {passwordRulesLabel?.data?.smsNotify && user.mobile_phone_c === user.mobilePhone &&
                <h6>{user.mobilePhone}</h6>
            }
          </div>
          <div className={'content-block dx-card responsive-paddings'}>
            <i className="icon-header-h3 main-color main-color-light dx-icon dx-icon-user"></i>
            <h4 className="mb20"><strong>Редактировать персональные данные</strong></h4>
            <form onSubmit={editFio} >
              <Form
                  id={'form-fio'}
                  formData={formDataFIO.current}
                  onFieldDataChanged={() => true}
                  labelLocation={'top'} labelMode={'floating'}
                  colCountByScreen={colCountByScreen}
                  colCount={3}
                  //disabled={disabledFIO}
              >
                <Item dataField="Фамилия" editorType={'dxTextBox'} editorOptions={fioEditor}>
                  <RequiredRule message="Фамилия задана неверно" />
                  <StringLengthRule min={2} message={strMinRuleMessage}/>
                  <PatternRule pattern={FIO_PATTERN} message={FAMILIA_ALLOWED_MESSAGE} />
                </Item>
                <Item dataField="Имя" editorType={'dxTextBox'} editorOptions={fioEditor}>
                  <RequiredRule message="Имя задано неверно" />
                  <StringLengthRule min={2} message={strMinRuleMessage}/>
                  <PatternRule pattern={FIO_PATTERN} message={IMYA_ALLOWED_MESSAGE} />
                </Item>
                <Item dataField="Отчество" editorType={'dxTextBox'} editorOptions={fioEditor}>
                  <PatternRule pattern={FIO_PATTERN_OPTIONAL} message={OTCHESTVO_ALLOWED_MESSAGE} />
                </Item>
                <GroupItem colSpan={3}>
                  <Item>
                    <div className="text">{FIO_ALLOWED_MESSAGE}</div>
                  </Item>
                </GroupItem>

                {!passwordRulesLabel?.data?.smsNotify &&
                    <Item dataField="phone" editorType="dxTextBox" editorOptions={phoneOptions}>
                      <Label text="Телефон" />
                      <RequiredRule message="Введите номер телефона!" />
                    </Item>
                }
                <Item dataField="region" colSpan={passwordRulesLabel?.data?.smsNotify ? 2 : 1} editorType="dxSelectBox" editorOptions={regionOptions}>
                  <Label text="Регион"/>
                  <RequiredRule message="Выберите регион!" />
                </Item>
                <ButtonItem cssClass='w100'>
                  <ButtonOptions
                      icon={disabledFIO ? "edit" : "save"}
                      text={disabledFIO ? "Редактировать" : "Сохранить"}
                      useSubmitBehavior={true}
                      type="default"
                  ></ButtonOptions>
                </ButtonItem>
              </Form>
            </form>
          </div>
          {passwordRulesLabel?.data?.smsNotify &&
              <div className={'content-block dx-card responsive-paddings'}>
                <i className="icon-header-h3 main-color main-color-light dx-icon dx-icon-email"></i>
                <h4 className="mb20"><strong>Редактировать email</strong></h4>
                <form className={'formEmailProfil'} onSubmit={editEmail} >
                  <Form
                      id={'form-email'}
                      formData={formDataEmail.current}
                      onFieldDataChanged={e => true}
                      labelLocation={'top'}
                      labelMode={'floating'}
                      colCountByScreen={colCountByScreen}
                      colCount={3}
                      onInitialized ={(e) => formInstanceEmail = e.component}
                  >

                    <Item
                        dataField={'email'}
                        editorType={'dxTextBox'}
                        editorOptions={emailOptions}
                    >
                      <RequiredRule message="Email обязателен" />
                      <EmailRule message="Email задан неверно" />
                      <Label visible={false} />
                    </Item>
                    <Item></Item>
                    <ButtonItem cssClass='w100'>
                      <ButtonOptions
                          text={"Подтвердить email"}
                          useSubmitBehavior={true}
                          type="default"
                          disabled={disableEmailSendWhereEquvivOldAndNew}
                      ></ButtonOptions>
                    </ButtonItem>
                  </Form>
                </form>
              </div>
          }
          {passwordRulesLabel?.data?.smsNotify &&
              <div className={'content-block dx-card responsive-paddings'}>
                <i className="icon-header-h3 main-color main-color-light dx-icon dx-icon-tel"></i>
                <h4 className="mb20"><strong>Редактировать телефон</strong></h4>
                <form className={'formEmailProfil'} onSubmit={editPhone} >
                  <Form
                      id={'form-phone'}
                      formData={formDataMobilePhone.current}
                      labelLocation={'top'}
                      labelMode={'floating'}
                      colCountByScreen={colCountByScreen}
                      colCount={3}
                      onInitialized ={(e) => formInstancePhone = e.component}
                  >

                    <Item
                        dataField={'phone'}
                        editorType={'dxTextBox'}
                        editorOptions={mobilePhoneOptions}
                    >
                      <RequiredRule message="Введите номер телефона!" />
                      <Label text="Телефон"/>
                    </Item>
                        <SimpleItem>
                          <SmsPopupDifferent typeOp={typeOp} formData={formDataMobilePhone.current}
                                    setTimerStart={setTimerStart}
                                    timerStart={timerStart}
                                    messageSendSms={messageSendSms}
                                    selectedValueRadio={1}
                                    uid={uid}
                                    authSettings={authSettings}
                                    lifeTimeSeconds={lifeTimeSeconds}
                                    setLifeTimeSeconds={setLifeTimeSeconds}
                                    setMessageSendSms={setMessageSendSms} ></SmsPopupDifferent>
                        </SimpleItem>
                    <ButtonItem cssClass='w100'>
                      <ButtonOptions
                          /*icon={disabledFIO ? "edit" : "save"}*/
                          text={profileSmsRemaining ? `Получить код ${formatSmsCountdown(profileSmsRemaining)}` : "Получить код"}
                          useSubmitBehavior={true}
                          type="default"
                          disabled={profileSmsRemaining || disablePhoneSendWhereEquvivOldAndNew}
                      ></ButtonOptions>
                    </ButtonItem>
                  </Form>
                </form>
                <LoadPanel message={messageLoadPanel} visible={loading} />
              </div>
          }
          {user.is_active_email &&
              <div className={'content-block dx-card responsive-paddings'}>
            <i className="icon-header-h3 main-color main-color-light dx-icon dx-icon-edit"></i>
            <h4 className="mb20"><strong>Редактировать пароль</strong></h4>
            <form onSubmit={editPassword}>
              <Form
                  id={'form-pass'}
                  formData={formDataPass.current}
                  onFieldDataChanged={() => true}//e.dataField === 'Notes' && setNotes(e.value)
                  labelLocation={'top'}
                  labelMode={'floating'}
                  colCountByScreen={colCountByScreen}
                  onInitialized={(e) => formInstancePass = e.component}
              >
                <GroupItem colSpan={1}>
                  <Item dataField="Текущий_пароль" editorType={'dxTextBox'} editorOptions={passwordCurrentEditor}/>
                </GroupItem>
                <Item dataField="Новый_пароль" editorType={'dxTextBox'} editorOptions={passwordEditor}>
                  {/*<CustomRule*/}
                  {/*  message={'Пароли не совпадают'}*/}
                  {/*  validationCallback={checkPassword}*/}
                  {/*/>*/}
                  <PatternRule pattern="^.*$" message={passwordRulesLabel.passTxt}/>
                  <StringLengthRule min={8} message={passwordRulesLabel.passTxt}/>
                  <RequiredRule message={'Пароль обязателен'}/>
                </Item>
                <Item dataField="Подтверждение_пароля" editorType={'dxTextBox'} editorOptions={passwordConfirmEditor}>
                  <CustomRule
                      message={'Пароли не совпадают'}
                      validationCallback={confirmPassword}
                  />
                </Item>
                <Item>
                  <div className="text">{passwordRulesLabel.passTxt}</div>
                </Item>
                <ButtonItem cssClass='w100'>
                  <ButtonOptions
                      icon="trash"
                      text="Удалить профиль"
                      onClick={() => onBtnPopupClick()}
                  ></ButtonOptions>
                </ButtonItem>
                <ButtonItem cssClass='w100'>
                  <ButtonOptions
                      icon={disabledPass ? "edit" : "save"}
                      text={disabledPass ? "Редактировать" : "Сохранить"}
                      useSubmitBehavior={true}
                      type="default"
                  ></ButtonOptions>
                </ButtonItem>
              </Form>
            </form>
          </div>}
          {false && process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' &&
              <div className={'content-block dx-card responsive-paddings'}>
                <i className="icon-header-h3 main-color main-color-light dx-icon dx-icon-edit"></i>
                <h4 className="mb20"><strong>Дополнительно</strong></h4>
                <form onSubmit={saveDopInfo}>
                  <Form
                      id={'form-pass'}
                      formData={formDataFile.current}
                      onFieldDataChanged={e => true}//e.dataField === 'Notes' && setNotes(e.value)
                      labelLocation={'top'}  labelMode={'floating'}
                      colCount={12}
                  >

                    <Item colSpan={6}>
                      Загрузить МЧД
                      <ExtFileUploader disabledForms={false} ref={extFileUploaderRef1} setfile={(e) => onValueChanged(e,'мчд') }></ExtFileUploader>
                    </Item>
                    <Item colSpan={6}>
                      Загрузить ЭЦП
                      <ExtFileUploader disabledForms={false} ref={extFileUploaderRef2} setfile={(e) => onValueChanged(e,'эцп') }></ExtFileUploader>
                    </Item>
                    <Item colSpan={4} dataField={'ras_email'} editorType={'dxCheckBox'}  editorOptions={{
                      text: 'Получать рассылку новостей по e-mail'
                    }}>
                      <Label visible={false} />
                    </Item>
                    <Item colSpan={4} dataField={'numeric'} editorType={'dxCheckBox'}  editorOptions={{
                      text: 'Получать уведомление о статусе обращения по e-mail'
                    }}>
                      <Label visible={false} />
                    </Item>
                    <Item colSpan={4} dataField={'notification_sms'} editorType={'dxCheckBox'}  editorOptions={{
                      text: 'Получать уведомления по SMS'
                    }}>
                      <Label visible={false} />
                    </Item>
                    <Item colSpan={4}/>
                    <Item colSpan={4}/>
                    <ButtonItem colSpan={4} cssClass='w100'>
                      <ButtonOptions
                          icon={"save"}
                          text={"Сохранить"}
                          useSubmitBehavior={true}
                          type="default"
                      ></ButtonOptions>
                    </ButtonItem>
                  </Form>
                </form>
              </div>
          }
          <Popup
              visible={visible}
              hideOnOutsideClick={true}
              showCloseButton={true}
              onHiding={() => setVisible(false)}
              showTitle={true}
              maxWidth={600}
              maxHeight={'90%'}
              height={'auto'}
              titleRender={()=>PopupTitleWithIcon(faUserMinus, "Удаление профиля!",() => setVisible(false))}
          >
            <div>Вы уверены что хотите удалить свой профиль в личном кабине?</div>
            <div className='w100 d-flex flex-wrap justify-content-center'>
              <Button
                  icon="close"
                  text="Закрыть"
                  width={200}
                  onClick={() => setVisible(false)}
                  className='mr-sm-3 mt-4'
              />
              <Button
                  icon="trash"
                  text="Удалить профиль"
                  width={200}
                  onClick={() => onDelProfileClick()}
                  className='mt-4'
              />
            </div>
          </Popup>
        </div>
      </React.Fragment>
  );
};

const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 3
};

export default Profile
